import React, { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectArmazem from "../../../components/Select/Armazem";
import SelectFixo from "../../../components/SelectFixo";
import UploadFiles from "../../../components/UploadFiles";
import TrelloBoard from "../../../components/TrelloBoard";
import SubmitForm from "../../../components/SubmitForm";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { format, parse } from "date-fns";

import Solicitacao from "../../../../lib/json/consultas/Solicitacao.json"
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"
import ConsultaContaContabil from "../../../../lib/json/consultas/ContaContabil.json"

import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, calcularDiferencaEmDias, converteDataProtheus, formatDateColumnCard, formatarMoeda2, parseLocaleNumber } from "../../../contents/VariaveisGlobais";
import ConsultaTotvs from "../../../../backend/ConsultaTotvs";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import BuscaProduto from "../../../components/BuscaProduto";
import { LabelInput } from "../../../components/InputGeral/styles";
import { HRDivider } from "../../CRM/Cadastros/FichaEtapa/styles";
import SelectFinalidade from "../../../components/Select/Finalidade";
import { handleQtdUnitarioCard, handleValorTotalCard, handleObservacaoInterna, handleAnexos } from "../../../components/GridCell/Solicitacao";
import { handleCentroCustoLabel } from "../../../components/GridCell/Pedido";

function FichaSolicitacaoCompra({idSolicitacaoCompras: propIdSolicitacaoCompras,
  itemSolicitacaoCompras: propItemSolicitacaoCompras,
  empresaFilialCompras: propEmpresaFilialCompras,
  empresaFilialDestino: propEmpresaFilialDestino,
}) {
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar') || propIdSolicitacaoCompras;
    const isCopiar = window.location.href.includes('Copiar');
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    
    // const { idSolicitacaoCompras, itemSolicitacaoCompras, empresaFilialCompras, empresaFilialDestino } = useParams();
    const {
        idSolicitacaoCompras: urlId,
        itemSolicitacaoCompras: urlItem,
        empresaFilialCompras: urlEmpresaFilial,
        empresaFilialDestino: urlDestino
    } = useParams();

    // Use prop se existir, senão use o valor da URL
    const idSolicitacaoCompras = propIdSolicitacaoCompras ?? urlId;
    const itemSolicitacaoCompras = propItemSolicitacaoCompras ?? urlItem;
    const empresaFilialCompras = propEmpresaFilialCompras ?? urlEmpresaFilial;
    const empresaFilialDestino = propEmpresaFilialDestino ?? urlDestino;

    const [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [disabledCabecalho, setDisabledCabecalho] = useState((isFormVisual || idSolicitacaoCompras));    
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    const [campoItem, setCampoItem] = useState();
    const [campoProduto, setCampoProduto] = useState();
    const [campoUnidade, setCampoUnidade] = useState("");
    const [campoQuantidade, setCampoQuantidade] = useState(0);
    const [campoValorUnitario, setCampoValorUnitario] = useState(formatarMoeda2(0,4));
    const [campoValorTotal, setCampoValorTotal] = useState(formatarMoeda2(0,2));
    const [campoDescricaoComplementar, setCampoDescricaoComplementar] = useState("");
    const [campoArmazem, setCampoArmazem] = useState({value: '', label: 'Selecione o Armazém'});
    const [campoPrioridade, setCampoPrioridade] = useState({value: '', text: 'Selecione a Prioridade' });
    const [campoDataNecessidade, setCampoDataNecessidade] = useState('');
    const [campoContaContabil, setCampoContaContabil] = useState({value: '', label: 'Selecione a Conta Contabil'});
    const [campoCentroCusto, setCampoCentroCusto] = useState({value: '', label: 'Selecione o Centro de Custo'});
    const [campoCentroCustoReposicao, setCampoCentroCustoReposicao] = useState({value: '', label: 'Selecione o Centro de Custo de Reposição'});
    const [campoEnderecoEntrega, setCampoEnderecoEntrega] = useState("");
    const [campoObservacaoInterna, setCampoObservacaoInterna] = useState("");
    const [campoObservacaoFornecedor, setCampoObservacaoFornecedor] = useState("");
    const [campoAnexos, setCampoAnexos] = useState([]);
    const [campoAnexosItem, setCampoAnexosItem] = useState([]);
    const [campoNumero, setCampoNumero] = useState( isCopiar ? "" : idSolicitacaoCompras);
    const [campoTipoCompra, setCampoTipoCompra] = useState({value:'', label: 'Selecione a Finalidade'});
    const [campoLocado, setCampoLocado] = useState(0);
    const [campoNumeroNF, setCampoNumeroNF] = useState("");
    const [campoPeriodicidade, setCampoPeriodicidade] = useState({value: '', label: ''});
    const [campoCA, setCampoCA] = useState('');
    const [campoAprovacaoNecessidade, setCampoAprovacaoNecessidade] = useState();
    const [campoSolicitante, setCampoSolicitante] = useState(usuarioProtheus);
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [obrigatorioValor, setObrigatorioValor] = useState(false);
    const [tipoCentroCusto, setTipoCentroCusto] = useState('');
    
    const [dataItensSolicitacao, setDataItensSolicitacao] = useState([]);
    
    const [diasSLA, setDiasSLA] = useState('');
    const [dataMinima, setDataMinima] = useState(format(currentDate, 'yyyy-MM-dd'));
    
    const [queryProduto, setQueryProduto] = useState('');
    const [queryCentroCusto, setQueryCentroCusto] = useState('');
    const [queryCentroCustoReposicao, setQueryCentroCustoReposicao] = useState('');
    const [queryContaContabil, setQueryContaContabil] = useState('');
    
    const [opcoesContaContabil, setOpcoesContaContabil] = useState([]);

    const options = [
        {
            value: '1',
            text: "Normal",
        },
        {
            value: '2',
            text: "Regularização",
        },
        {
            value: '3',
            text: "Emergencial",
        },
        {
            value: '5',
            text: "Reposição",
        },
        {
            value: '6',
            text: "Compra Direta",
        }
    ];

    const loadSolicitacaoCompras = async() => {
        
        if ( idSolicitacaoCompras ) {
            let consultaDefault = Solicitacao.consulta;
        
            consultaDefault += "AND C1_FILIAL = FILIAL(SC1) ";
            consultaDefault += "AND C1_NUM = '" + idSolicitacaoCompras + "' ";
			consultaDefault += "ORDER BY C1_NUM, C1_ITEM	 ";

            setCarregar(true);
            var retConsulta = await ConsultaTotvs( consultaDefault, Solicitacao.tabelas, empresaFilialCompras );

            if (empresaFilialDestino){
                setEmpresaFilialSelect(empresaFilialDestino) 
            }
            
            if (retConsulta.data){
                let aItens = []
                retConsulta.data.map( (item, index) => {
                    const prioridadeOption = options.filter( (option) => option.value === (item.C1_XFLUXSC || "1"))
                    const cPeriodo = item.C1_XPERIO === 'D' ? 'Dias ' : item.C1_XPERIO === 'M' ? 'Meses ' : item.C1_XPERIO === 'A' ? 'Anos ' : ''

                    // let newId = Date.now()
                    let Solicitante = {value: item.C1_USER, label: item.C1_SOLICIT}
                    let Produto = {value: item.C1_PRODUTO, label: item.C1_PRODUTO + ' - ' + item.DESCRI, descricaoBD: item.C1_DESCRI}
                    let Armazem = {value: item.C1_LOCAL, label: item.C1_LOCAL + ' - ' + item.NNR_DESCRI}
                    let ContaContabil = {value: item.C1_CONTA, label: item.C1_CONTA + ' - ' + item.CT1_DESC01}
                    let CentroCusto = {value: item.C1_CC, label: item.C1_CC + ' - ' + item.CTT_DESC01}
                    let CentroCustoReposicao = {value: item.C1_XCCR, label: item.C1_XCCR + ' - ' + item.CC_REP}
                    let Prioridade = {value: item.C1_XFLUXSC, text: prioridadeOption[0].text }
                    let TipoCompra = {value: item.C1_TIPCOM, label: item.C1_TIPCOM + " - " + item.DHK_DESCR, origem: { DHK_XPRDIN: item.DHK_XPRDIN, DHK_XPRDFN: item.DHK_XPRDFN, DHK_XDSLA: item.DHK_XDSLA, DHK_XGRPRD: item.DHK_XGRPRD} } 
                    let Periodocidade = {value: item.C1_XPERIO.trim(), text: cPeriodo}
                    let dataNecessidade = converteDataProtheus(item.C1_DATPRF);
                    let dataEmissao = converteDataProtheus(item.C1_EMISSAO);
                    let dataAprovacao = item.C1_XDTAPRV.trim() ? converteDataProtheus(item.C1_XDTAPRV) : dataNecessidade;
                    
					if (isCopiar){
                        dataEmissao = format(currentDate, 'yyyy-MM-dd');
                    }
					
					let diasDif = item.C1_XDTAPRV.trim() ? calcularDiferencaEmDias(dataEmissao, dataNecessidade) : 0;
                    
					if (diasDif > 0){
                        dataAprovacao = parse(dataAprovacao, 'yyyy-MM-dd', new Date())
                        dataAprovacao.setDate(dataAprovacao.getDate() + diasDif);
                        dataAprovacao = format(dataAprovacao, 'yyyy-MM-dd');
                    }

                    setCampoSolicitante(Solicitante);
                    
					if (!isCopiar){
                        setCampoDataEmissao(dataEmissao);
                    }
					
                    setCampoTipoCompra(TipoCompra);
                    handleRegraTipoCompra(TipoCompra)
                    setCampoPrioridade(Prioridade);
                    handleDataMinima(Prioridade);

                    if (item.DHK_XPRDIN || item.DHK_XPRDFN || item.DHK_XGRPRD){
                        let cQueryProduto = ''
                        
                        // if (item.DHK_XPRDIN){
                        //     cQueryProduto += " AND B1_COD >= '" + item.DHK_XPRDIN + "' "
                        // }
                        
                        // if (item.DHK_XPRDFN){
                        //     cQueryProduto += " AND B1_COD <= '" + item.DHK_XPRDFN + "' "
                        // }

                        if (item.DHK_XGRPRD.trim().slice(0,-1)){
                            cQueryProduto += " AND B1_GRUPO IN ('" + item.DHK_XGRPRD.trim().slice(0,-1).replaceAll(';', "','") + "') "
                        }

                        setQueryProduto(cQueryProduto)
                    }

                    const cAnexoItem = item.C1_XANEXO.trim() || '[]'; //Campo Tabela Sistema
                    const cAnexoSC = item.C1_XANXSC.trim() || '[]'; //Campo Tabela Sistema
                    
                    if ( (itemSolicitacaoCompras && itemSolicitacaoCompras === item.C1_ITEM) || (itemSolicitacaoCompras === '0000' && index === 0) ){
                        let cFilial = item.C1_FILIAL
                        
                        setCampoItem(item.C1_ITEM)

                        if (!empresaFilialDestino){
                            setEmpresaFilialSelect("01"+cFilial) 
                        }
                        
                        setCampoUnidade(item.C1_UM) 
                        setCampoQuantidade(formatarMoeda2(item.C1_QUANT,4)) 
                        setCampoLocado(item.C1_XLOC)
                        setCampoNumeroNF((item.C1_XNF || "").trim())
                        setCampoCA(item.C1_XCA)
                        setCampoPeriodicidade(Periodocidade)
                        setCampoValorUnitario(formatarMoeda2(parseFloat(item.C1_PRECO),4)) 
                        setCampoValorTotal(formatarMoeda2(parseFloat(item.C1_TOTAL),2)) 
                        setCampoDataNecessidade(dataNecessidade) 
                        setCampoDescricaoComplementar(item.C1_OBS) 
                        setCampoProduto(Produto)
                        setCampoArmazem(Armazem)
                        setCampoContaContabil(ContaContabil)
                        setCampoCentroCusto(CentroCusto)
                        setCampoCentroCustoReposicao(CentroCustoReposicao)
                        setCampoAprovacaoNecessidade(dataAprovacao)
                        setCampoEnderecoEntrega(item.C1_XENDENT)
                        setCampoObservacaoInterna(item.C1_XOBSINT)
                        setCampoObservacaoFornecedor(item.C1_XOBSFOR)
                        setCampoAnexosItem( JSON.parse(cAnexoItem))
                        setCampoAnexos( JSON.parse(cAnexoSC))
                    }

                    aItens.push({ numero: isCopiar ? "" : item.C1_NUM,
                            item: item.C1_ITEM,  
                            produto: Produto,
                            descricaoComplementar: item.C1_OBS,
                            unidadeMedida: item.C1_UM, 
                            quantidade: formatarMoeda2(parseFloat(item.C1_QUANT,4)), 
                            valorUnitario: formatarMoeda2(parseFloat(item.C1_PRECO),4), 
                            valorTotal: formatarMoeda2(parseFloat(item.C1_TOTAL),2), 
                            prioridade: Prioridade,
                            dataNecessidade: dataNecessidade,
                            campoArmazem: Armazem,
                            campoContaContabil: ContaContabil,
                            campoCentroCusto: CentroCusto,
                            campoCentroCustoReposicao: CentroCustoReposicao,
                            enderecoEntrega: item.C1_XENDENT, //Campo Tabela Sistema
                            observacaoInterna: item.C1_XOBSINT, //Campo Tabela Sistema
                            observacaoFornecedor: item.C1_XOBSFOR, //Campo Tabela Sistema
                            anexoitem: cAnexoItem, //Campo Tabela Sistema
                            anexosc: cAnexoSC, //Campo Tabela Sistema
                            solicitante: Solicitante,
                            tipoCompra: TipoCompra,
                            dataAprovacao: dataAprovacao,
                            emissao: dataEmissao,
                            periodicidade: Periodocidade,
                            certificado: item.C1_XCA,
                            locado: (item.C1_XLOC || "").trim(),
                            numeroNF: (item.C1_XNF || "").trim(),
                            deletado: false
                    })
                });

                setDataItensSolicitacao(aItens);
            }

            setCarregar(false);
        }
    }

    useEffect( () => {
        const fetchData = async() => {
            await loadSolicitacaoCompras()
        }

        fetchData()
    }, []);

    const columnsItensSolicitacao = [
        {
            Header: 'Produto',
            accessor: 'produto.label',
        },
        {
            Header: 'U. M.',
            accessor: 'unidadeMedida',
        },
        {
            Header: 'Qtde.',
            accessor: 'quantidade',
            render: handleQtdUnitarioCard
        },
        {
            Header: 'Valor Total',
            accessor: 'valorTotal',
            render: handleValorTotalCard
        },
        {
            Header: 'Centro de Custo',
            accessor: 'campoCentroCusto.label',
            render: handleCentroCustoLabel
        },
        {
            Header: 'Data Necessidade',
            accessor: 'dataNecessidade',
            render: formatDateColumnCard
        },
    ]

    const columnsAditional = [
        {
            Header: 'Prioridade',
            accessor: 'prioridade.text',
        },
        {
            Header: 'Conta Contabil',
            accessor: 'campoContaContabil.label',
        },
        {
            Header: 'Descrição Complementar',
            accessor: 'descricaoComplementar'
        },
        {
            Header: 'Observação Interna',
            accessor: 'observacaoInterna',
            render: handleObservacaoInterna
        },
        {
            Header: 'Anexos SC',
            accessor: 'anexosc',
            render: handleAnexos
        },
        {
            Header: 'Anexos Item',
            accessor: 'anexoitem',
            render: handleAnexos
        },
    ]

    const handleTipoCompra = (selectedOption) =>{
        setCampoTipoCompra(selectedOption)
        handleRegraTipoCompra(selectedOption)

        if (campoDataEmissao && selectedOption.value.trim() && campoPrioridade.value.trim()){
            setDisabledCabecalho(true)
        }
    }

    const handleRegraTipoCompra = (selectedOption) => {
        if (selectedOption?.origem){
            let item = selectedOption.origem;
    
            if (item.DHK_XPRDIN || item.DHK_XPRDFN || item.DHK_XGRPRD){
                let cQueryProduto = ''
                
                // if (item.DHK_XPRDIN){
                //     cQueryProduto += " AND B1_COD >= '" + item.DHK_XPRDIN + "' "
                // }
                
                // if (item.DHK_XPRDFN){
                //     cQueryProduto += " AND B1_COD <= '" + item.DHK_XPRDFN + "' "
                // }

                switch (selectedOption.value) {
                    case window._env_?.REACT_APP_FINALIDADE_APLICACAO:
                        cQueryProduto += " AND ( ( BM_XCTAVLO != '' AND BM_XCTAVLC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_CONSUMO:
                        cQueryProduto += " AND ( ( BM_XCTCONO != '' AND BM_XCTCONC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_LOCACOES:
                        cQueryProduto += " AND ( ( BM_XCTLOCO != '' AND BM_XCTLOCC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SERVICOS:
                        cQueryProduto += " AND ( ( BM_XCTSERO != '' AND BM_XCTSERC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EPI:
                        cQueryProduto += " AND ( ( BM_XCTEPIO != '' AND BM_XCTEPIC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_REVENDA:
                        cQueryProduto += " AND ( ( BM_XCTREVO != '' AND BM_XCTREVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_ATIVO:
                        cQueryProduto += " AND ( ( BM_XCTATVO != '' AND BM_XCTATVC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_BRINDE:
                        cQueryProduto += " AND ( ( BM_XCTBRNO != '' AND BM_XCTBRNC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_EXTRAVIO:
                        cQueryProduto += " AND ( ( BM_XCTIEXO != '' AND BM_XCTIEXC != '' ) "
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO:
                        cQueryProduto += " AND ( ( BM_XCTISBO != '' AND BM_XCTISBC != '' ) "                    
                        break;
                    case window._env_?.REACT_APP_FINALIDADE_MANUTENCAO:
                        cQueryProduto += " AND ( ( BM_XCTIMNO != '' AND BM_XCTIMNC != '' ) "
                        break;
                    default:
                        cQueryProduto += " AND ( ( 1 = 1  ) "
                        break;
                }
                
                if (item.DHK_XGRPRD.trim().slice(0,-1)){
                    cQueryProduto += " OR B1_GRUPO IN ('" + item.DHK_XGRPRD.trim().slice(0,-1).replaceAll(';', "','") + "')  "
                }
                
                cQueryProduto += " ) "
        
                setQueryProduto(cQueryProduto)
            }
    
            setDiasSLA(parseInt(item.DHK_XDSLA))
        }
    }

    const handleChangePrioridade = (selectedOption) =>{
        setCampoPrioridade(selectedOption)
        handleDataMinima(selectedOption)

        if (campoDataEmissao && campoTipoCompra.value.trim() && selectedOption.value.trim()){
            setDisabledCabecalho(true)
        }
    }

    const handleDataMinima = (selectedOption) => {
        let diasSLAData = diasSLA
        let data = currentDate; // Data atual

        if (selectedOption.value === '3'){
            setDiasSLA(0)
            diasSLAData = 0;
        }

        if (diasSLAData > 0){
            data.setDate(data.getDate() + diasSLAData);
        }
        
        setDataMinima(format(data, 'yyyy-MM-dd'))
        setCampoDataNecessidade(format(data, 'yyyy-MM-dd'))
    }

    const handleProduto = (e) =>{
        if (e){
            // let contaProduto = e.origem.B1_CONTA
            let contabil = [
                { finalidade: 'Produto',                                          operacional: e.origem.B1_XCONTA,     corporativo: e.origem.B1_CONTA  },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_APLICACAO,       operacional: e.origem.BM_XCTAVLO,   corporativo: e.origem.BM_XCTAVLC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_CONSUMO,         operacional: e.origem.BM_XCTCONO,   corporativo: e.origem.BM_XCTCONC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_LOCACOES,        operacional: e.origem.BM_XCTLOCO,   corporativo: e.origem.BM_XCTLOCC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SERVICOS,        operacional: e.origem.BM_XCTSERO,   corporativo: e.origem.BM_XCTSERC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EPI,             operacional: e.origem.BM_XCTEPIO,   corporativo: e.origem.BM_XCTEPIC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_REVENDA,         operacional: e.origem.BM_XCTREVO,   corporativo: e.origem.BM_XCTREVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_ATIVO,           operacional: e.origem.BM_XCTATVO,   corporativo: e.origem.BM_XCTATVC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_BRINDE,          operacional: e.origem.BM_XCTBRNO,   corporativo: e.origem.BM_XCTBRNC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_EXTRAVIO,        operacional: e.origem.BM_XCTIEXO,   corporativo: e.origem.BM_XCTIEXC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_SUBSTITUICAO,    operacional: e.origem.BM_XCTISBO,   corporativo: e.origem.BM_XCTISBC },
                { finalidade: window._env_?.REACT_APP_FINALIDADE_MANUTENCAO,      operacional: e.origem.BM_XCTIMNO,   corporativo: e.origem.BM_XCTIMNC }
            ]
            
            setCampoUnidade( (e.origem ? e.origem.B1_UM : '') )
            setCampoProduto( { value: e.value, label: e.label, descricaoBD: e.origem.B1_DESC } )
            setOpcoesContaContabil(contabil);

            setObrigatorioValor(e.origem.BM_XVLOBR === 'S' ? true : false)

            return
        }
        
        setCampoProduto()
        setCampoUnidade( "" )
        setOpcoesContaContabil([]);        
    }

    const handleArmazem = (e) =>{
        let cConsulta = !e.origem ? "" : ConsultaCentroCusto.consulta + 
                                         " WHERE CTT_FILIAL = FILIAL(CTT) " + 
                                         " AND CTT.D_E_L_E_T_ <> '*'" +
                                         " AND CTT_CLASSE = '2'" +
                                         " AND CTT_BLOQ = '2'" +
                                         " AND CTT_CUSTO = '" + e.origem.NNR_XCC + "'"

        setQueryCentroCusto(cConsulta)
        setQueryCentroCustoReposicao( cConsulta.replace('CTT_CUSTO =', 'CTT_CUSTO !=') )
        setCampoArmazem( { value: e.value, label: e.label } )
        
        //Sempre que altera o Armazem, deve limpar o Centro de Custo e a Conta Contabil
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'})
        setTipoCentroCusto('')
        setCampoCentroCustoReposicao({value: '', label: 'Selecione o Centro de Custo de Reposição'})        
        setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'});

        setQueryContaContabil('')
    }

    const handleAddFilesSC = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC, TXT, planilhas do Excel ou arquivos CSV.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFilesSC = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexosItem, ...newFiles]
            setCampoAnexosItem(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexosItem];
        updatedFiles.splice(fileDelete, 1);
        
        setCampoAnexosItem(updatedFiles)
        return updatedFiles;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    const handleCampoQuantidade = (e) => {
        const inputValue = e.target.value;

        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoValorUnitario)
    
            setCampoQuantidade(inputValue)
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleCampoValorUnitario = (e) => {
        const inputValue = e.target.value;
        
        // Validate if the input is a valid number with up to 6 decimals
        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoQuantidade)

            setCampoValorUnitario(inputValue)
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleSaveItem = () => {
        if (!campoDataEmissao){
            ErroMsg("Selecione a Data de Emissão")
            return;
        }
        if (!campoTipoCompra.value.trim()){
            ErroMsg("Selecione a Finalidade da Compra")
            return;
        }
        if (!campoPrioridade.value.trim()){
            ErroMsg("Selecione a Prioridade da Compra")
            return;
        }
        if (!campoSolicitante){
            ErroMsg("Selecione o Solicitante")
            return;
        }
        if (!campoProduto){
            ErroMsg("Selecione o Produto")
            return;
        }
        if (parseLocaleNumber(campoQuantidade) <=0){
            ErroMsg("Informe a quantidade");
            return;
        }
        if (parseLocaleNumber(campoValorTotal) <= 0) {
            ErroMsg("O valor total do item deve ser maior que zero.");
            return;
        }
        if (!campoArmazem.value){
            ErroMsg("Informe o Armazém")
            return;
        }
        if (campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_EPI && !campoCA){
            ErroMsg("Informe o Certificado de Aprovação do EPI")
            return;
        }
        if (campoPrioridade.value === '2' && !campoNumeroNF.trim() ){
            ErroMsg("Informe o Número da NF, para SC do tipo Regularização")
            return;
        }

        if (campoItem){
            const id = campoItem
            
            setDataItensSolicitacao((prevData) => {
                return prevData.map((item) => {
                    if (item.item === id){
                        return { ...item, 
                                produto: campoProduto,
                                descricaoComplementar: campoDescricaoComplementar,
                                unidadeMedida: campoUnidade, 
                                quantidade: campoQuantidade, 
                                valorUnitario: campoValorUnitario, 
                                valorTotal: campoValorTotal, 
                                prioridade: campoPrioridade,
                                dataNecessidade: campoDataNecessidade,
                                enderecoEntrega: campoEnderecoEntrega,
                                campoArmazem,
                                campoContaContabil,
                                campoCentroCusto,
                                campoCentroCustoReposicao,
                                observacaoInterna: campoObservacaoInterna,
                                observacaoFornecedor: campoObservacaoFornecedor,
                                anexoitem: campoAnexosItem ? JSON.stringify(campoAnexosItem) : "",
                                anexosc: campoAnexos ? JSON.stringify(campoAnexos) : "",
                                solicitante: campoSolicitante,
                                tipoCompra: campoTipoCompra,
                                dataAprovacao: campoAprovacaoNecessidade,
                                emissao: campoDataEmissao,
                                periodicidade: campoPeriodicidade,
                                certificado: campoCA,
                                locado: campoLocado,
                                numeroNF: campoNumeroNF,
                                deletado: false
                         };
                    }else{
                        return item;
                    } 
                })
            });

            setCampoItem('')
        }else{
            const dataLastItem = dataItensSolicitacao.findLast( (item) => item.item )
            const lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
            const item = String(lastItem + 1)

            setDataItensSolicitacao(
                (prevData) => [...prevData, 
                    {   numero: "", 
                        item: item.padStart(4, '0'),
                        produto: campoProduto,
                        descricaoComplementar: campoDescricaoComplementar,
                        unidadeMedida: campoUnidade, 
                        quantidade: campoQuantidade, 
                        valorUnitario: campoValorUnitario, 
                        valorTotal: campoValorTotal, 
                        prioridade: campoPrioridade,
                        dataNecessidade: campoDataNecessidade,
                        campoArmazem,
                        campoContaContabil,
                        campoCentroCusto,
                        campoCentroCustoReposicao,
                        enderecoEntrega: campoEnderecoEntrega,
                        observacaoInterna: campoObservacaoInterna,
                        observacaoFornecedor: campoObservacaoFornecedor,
                        anexoitem: campoAnexosItem ? JSON.stringify(campoAnexosItem) : "",
                        anexosc: campoAnexos ? JSON.stringify(campoAnexos) : "",
                        solicitante: campoSolicitante,
                        tipoCompra: campoTipoCompra,
                        dataAprovacao: campoAprovacaoNecessidade,
                        emissao: campoDataEmissao,
                        periodicidade: campoPeriodicidade,
                        certificado: campoCA,
                        locado: campoLocado,
                        numeroNF: campoNumeroNF,
                        deletado: false
                    },
                ]
            );
        }

        clearForm()
    }

    const handleCancelItem = () => {
        clearForm();
    }

    const handleAlterarItem = (item) => {
        setCampoPrioridade(item.prioridade)
        setCampoTipoCompra(item.tipoCompra)
        setCampoAprovacaoNecessidade(item.dataAprovacao)
        
        handleRegraTipoCompra(item.tipoCompra);
        handleDataMinima(item.prioridade);
        
        setCampoItem(item.item)
        setCampoProduto(item.produto)
        setCampoUnidade(item.unidadeMedida)
        setCampoQuantidade(formatarMoeda2(parseLocaleNumber(item.quantidade),4))
        setCampoCA(item.certificado)
        setCampoPeriodicidade(item.periodicidade)
        setCampoLocado(item.locado)
        setCampoNumeroNF(item.numeroNF)
        setCampoValorUnitario(formatarMoeda2(parseLocaleNumber(item.valorUnitario),4))
        setCampoValorTotal(formatarMoeda2(parseLocaleNumber(item.valorTotal),2))
        setCampoDescricaoComplementar(item.descricaoComplementar)
        setCampoArmazem(item.campoArmazem)
        setCampoDataNecessidade(item.dataNecessidade)
        setCampoContaContabil(item.campoContaContabil)
        setCampoCentroCusto(item.campoCentroCusto)
        setCampoCentroCustoReposicao(item.campoCentroCustoReposicao)
        setCampoEnderecoEntrega(item.enderecoEntrega)
        setCampoObservacaoInterna(item.observacaoInterna)
        setCampoObservacaoFornecedor(item.observacaoFornecedor)
        setCampoAnexosItem(JSON.parse(item.anexoitem))
    }

    const handleExcluirItem = (item) => {
        const id = item.item;

        setDataItensSolicitacao((prevData) => 
            prevData.map((item) => {
                if (item.item === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                }
            })
        );
    }

    const clearForm = () => {
        setQueryContaContabil("")
        setQueryCentroCusto("")
        setQueryCentroCustoReposicao("")
        setOpcoesContaContabil([])

        setCampoItem('')
        setCampoProduto();
        setCampoUnidade('');
        setCampoQuantidade(formatarMoeda2(0,4));
        setCampoCA('');
        setCampoPeriodicidade({value: '', text: ''});
        setCampoLocado(0);
        setCampoNumeroNF("");
        setCampoValorUnitario(formatarMoeda2(0,4));
        setCampoValorTotal(formatarMoeda2(0,2));
        setCampoDescricaoComplementar('');
        setCampoArmazem({value: '', label: 'Selecione o Armazém'});
        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'});
        setCampoCentroCustoReposicao({value: '', label: 'Selecione o Centro de Custo de Reposição'});
        setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'});
        setCampoEnderecoEntrega('');
        setCampoObservacaoInterna('');
        setCampoObservacaoFornecedor('');
        setCampoAnexosItem([]);
    } 

    const handleSalvar = async() =>{
        let cJSONInclusao;
        let cJSONAlteracao;
        let cJSONExclusao;
        let oRetorno
        const dataItensSalvar = dataItensSolicitacao.map((item) => { item.anexosc = JSON.stringify(campoAnexos); return item})
        
        let dataItemInclusao = dataItensSalvar.filter( (item) => item.deletado === false && item.numero === "" )
        let dataItemAlteracao
        let dataItemExclusao

        if (campoNumero){
            dataItemAlteracao = dataItensSalvar.filter( (item) => item.deletado === false )
            dataItemExclusao = dataItensSalvar.filter( (item) => item.deletado === true && item.numero !== "" )
            
            if (dataItemAlteracao.length > 0){
                cJSONAlteracao = JSON.stringify(dataItemAlteracao)
            }
            
            //Atualiza o Data Item Inclusão, adicionando o Numero da SC
            dataItemAlteracao = dataItemAlteracao.map((item) => {item.numero = campoNumero; return item})
            dataItemInclusao = []
        }

        if (dataItemInclusao.length > 0){
            cJSONInclusao = JSON.stringify(dataItemInclusao)
        }
        
        
        setCarregar(true)
        if (dataItemExclusao && campoNumero){
            dataItemExclusao.forEach( async(element) => {
                const cJSONExclusao = { 
                    Numero: element.numero,
                    Item: element.item,
                }

                oRetorno = await ConsumoTOTVS_POST('EXCLUIRSOLICITACAOCOMPRAS', cJSONExclusao, empresaFilial)
            });
        }
        if (cJSONInclusao){
            oRetorno = await ConsumoTOTVS_POST('NOVASOLICITACAOCOMPRAS', cJSONInclusao, empresaFilial)
        }
        if (cJSONAlteracao){
            oRetorno = await ConsumoTOTVS_POST('ALTERARSOLICITACAOCOMPRAS', cJSONAlteracao, empresaFilial)
        }
        
        setCarregar(false)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false
        }
    }

    const handleCampoCentroCusto = (e) => {
        setCampoEnderecoEntrega(e.origem.CTT_CEP + ' - ' + e.origem.CTT_ENDER.trim() + ', ' + e.origem.CTT_BAIRRO.trim() + ' - ' +  e.origem.CTT_MUNIC.trim() + '/' + e.origem.CTT_ESTADO.trim())
        setCampoCentroCusto({ value: e.value, label: e.label })
        setTipoCentroCusto(e.origem.CTT_XTIPO.trim())
    }

    const handleCampoCentroCustoReposicao = (e) => {
        setCampoEnderecoEntrega(e.origem.CTT_CEP + ' - ' + e.origem.CTT_ENDER.trim() + ', ' + e.origem.CTT_BAIRRO.trim() + ' - ' +  e.origem.CTT_MUNIC.trim() + '/' + e.origem.CTT_ESTADO.trim())
        setCampoCentroCustoReposicao({ value: e.value, label: e.label })
    }

    const handleCampoNumeroNF = () => {
        const value = campoNumeroNF.trim().padStart(9, '0');
        
        setCampoNumeroNF(value);
    }

    useEffect( () => {
        if (campoTipoCompra && tipoCentroCusto && opcoesContaContabil.length > 0){
            const contaProduto = (tipoCentroCusto === "2" ? opcoesContaContabil[0].operacional : opcoesContaContabil[0].corporativo).trim()
            
            if (contaProduto){
                let cConsulta = ConsultaContaContabil.consulta + 
                                " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
                                " AND CT1_CONTA = '" + (contaProduto) + "'"
                
                setQueryContaContabil(cConsulta)
            }else{
                let opcaoContaProduto = opcoesContaContabil.filter( (item) => item.finalidade === campoTipoCompra.value )

                if (opcaoContaProduto && opcaoContaProduto.length > 0){
                    let contaProduto = ( tipoCentroCusto === "2" ? opcaoContaProduto[0].operacional : opcaoContaProduto[0].corporativo).trim()
                    let cConsulta = ConsultaContaContabil.consulta + 
                                    " WHERE CT1_FILIAL = FILIAL(CT1) AND D_E_L_E_T_ != '*' " + 
                                    " AND CT1_CONTA = '" + (contaProduto) + "'"
                    
                    setQueryContaContabil(cConsulta)
                }else{
                    let cConsulta = ConsultaContaContabil.consulta + 
                                    " WHERE CT1_FILIAL = FILIAL(CT1) " +
                                    " AND D_E_L_E_T_ != '*' " +
                                    " AND CT1_CONTA = '' "
                    setCampoContaContabil({value: '', label: 'Selecione a Conta Contabil'})
                    setQueryContaContabil(cConsulta)
                }
            }
        }
    }, [campoTipoCompra, opcoesContaContabil, campoArmazem, tipoCentroCusto])

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text={`Solicitação de Compras ${isFormVisual ? ' - ' + idSolicitacaoCompras : ''}`}
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Dados da SC: </h5>
                        </Col>
                    </Row>

                    { campoNumero && 
                        <Row>
                            <Col md="3" xs="12">
                                <InputGeral
                                    label="Numero SC"
                                    placeholder="Numero SC"
                                    tipo="text"
                                    value={campoNumero}
                                    onChange={(e) => setCampoNumero(e)}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md="3" xs="12">
                            <SelectDinamico 
                                label="Solicitante"
                                campoValue={campoSolicitante}
                                value={campoSolicitante}
                                cValue="Usuario"
                                cText="Nome"
                                consulta="Usuario"
                                tabela="USER"
                                isMultiplo={false}
                                onchange={(e) => setCampoSolicitante(e)}
                                disabled={!usuarioLogado.permissao.incluirSolicitacao || disabledCabecalho}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data de Emissão"
                                placeholder="Data de Emissão"
                                tipo="date"
                                value={campoDataEmissao}
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={disabledCabecalho}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFinalidade
                                campoFinalidade={campoTipoCompra}
                                changeFinalidade={handleTipoCompra}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                filtraFilial={true}
                                showNoFilter={true}
                                disabled={disabledCabecalho}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFixo
                                options={options} 
                                value={campoPrioridade} 
                                selectedOptionValue={campoPrioridade} 
                                isLabel={true} 
                                label="Prioridade" 
                                onChange={handleChangePrioridade}
                                disabled={disabledCabecalho}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexo SC</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFilesSC}
                                onDeleteEvent={handleDelFilesSC}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    
                    { (campoDataEmissao && campoTipoCompra.value.trim() && campoPrioridade.value.trim()) && !disabledForm && (
                        <>
                            <HRDivider/>
                            <Row>
                                <Col md="10" xs="12">
                                    <h5>Dados Obrigatórios: </h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" xs="12">
                                    <BuscaProduto 
                                        empresaFilial={empresaFilial} 
                                        handleProduto={handleProduto} 
                                        campoProduto={campoProduto}
                                        queryComplemento={queryProduto}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Unid. Medida"
                                        placeholder="U.Medida"
                                        tipo="text"
                                        value={campoUnidade}
                                        onChange={(e) => setCampoUnidade(e.target.value)}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md="2" xs="12">
                                    <InputGeral
                                        label="Previsão Necessidade"
                                        placeholder="Previsão Necessidade"
                                        tipo="date"
                                        value={campoDataNecessidade}
                                        onChange={(e) => setCampoDataNecessidade(e.target.value)}
                                        min={dataMinima}
                                    />
                                </Col>
                                { campoAprovacaoNecessidade && 
                                    <Col md="2" xs="12">
                                        <InputGeral
                                            label="Data de Necessidade"
                                            placeholder="Data de Necessidade"
                                            tipo="date"
                                            value={campoAprovacaoNecessidade}
                                            onChange={(e) => setCampoAprovacaoNecessidade(e.target.value)}
                                            disabled={true}
                                        />
                                    </Col>
                                }
                            </Row>
                            <Row>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Quantidade"
                                        placeholder="Quantidade"
                                        tipo="monetario"
                                        decimal={4}
                                        value={campoQuantidade}
                                        onChange={(e) => handleCampoQuantidade(e)}
                                    />
                                </Col>
                                { campoTipoCompra && campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_EPI && (
                                    <Col md="3" xs="12">
                                        <InputGeral
                                            label={"CA"}
                                            placeholder={"Certificado de Aprovação"}
                                            tipo="text"
                                            value={campoCA}
                                            onChange={(e) => setCampoCA(e.target.value)}                                            
                                        />
                                    </Col>
                                )}
                                { campoTipoCompra && campoTipoCompra.value === window._env_?.REACT_APP_FINALIDADE_LOCACOES && (
                                    <>
                                        <Col md="2" xs="12">
                                            <SelectFixo
                                                options={[{value:'D', text:'Dias '},{value:'M', text:'Meses '},{value:'A', text:'Anos '}]} 
                                                value={campoPeriodicidade} 
                                                selectedOptionValue={campoPeriodicidade} 
                                                isLabel={true} 
                                                label="Periodo" 
                                                onChange={(e) => setCampoPeriodicidade(e)}
                                            />
                                        </Col>
                                        <Col md="1" xs="12">
                                            <InputGeral
                                                label={(campoPeriodicidade.text || "Locado") }
                                                placeholder={(campoPeriodicidade.text || "Locado")}
                                                tipo="numero"
                                                value={campoLocado}
                                                onChange={(e) => setCampoLocado(e.target.value)}
                                            />
                                        </Col>
                                    </>
                                )}
                                { campoPrioridade && campoPrioridade.value === '2' && (
                                    <Col md="3" xs="12">
                                        <InputGeral
                                            label="Numero NF"
                                            placeholder="Numero NF"
                                            tipo="text"
                                            value={campoNumeroNF}
                                            handleBlur={handleCampoNumeroNF}
                                            onChange={(e) => setCampoNumeroNF(e.target.value)}
                                            max={9}
                                        />
                                    </Col>
                                )}

                                { obrigatorioValor && 
                                    <>
                                        <Col md="4" xs="12">
                                            <InputGeral
                                                label="Valor Unitário"
                                                placeholder="Valor Unitário"
                                                tipo="monetario"
                                                value={campoValorUnitario}
                                                onChange={(e) => handleCampoValorUnitario(e)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="5" xs="12">
                                            <InputGeral
                                                label="Valor Total Meta"
                                                placeholder="Valor Total Meta"
                                                tipo="monetario"
                                                value={campoValorTotal}
                                                disabled={true}
                                                onChange={(e) => setCampoValorTotal(e)}
                                                decimal={2}
                                            />
                                        </Col>
                                    </>
                                }
                                <Col md="6" xs="12">
                                    <SelectArmazem
                                        campoLocalEstoque={campoArmazem}
                                        changeLocalEstoque={handleArmazem}
                                        empresaLogada={empresaFilial}
                                        filtraFilial={true}
                                        returnOriginal={true}
                                        showNoFilter={true}
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectContaContabil
                                        campoContaContabil={campoContaContabil}
                                        changeContaContabil={setCampoContaContabil}
                                        queryContaContabil={queryContaContabil}
                                        empresaLogada={empresaFilial}
                                        disabled={true}
                                        loadDefault={false}
                                        selectUnique={true}
                                    />
                                </Col>
                                <Col md="6" xs="12">
                                    <SelectCentroCusto 
                                        campoCentroCusto={campoCentroCusto}
                                        changeCentroCusto={handleCampoCentroCusto}
                                        empresaLogada={empresaFilial}
                                        queryCentroCusto={queryCentroCusto}
                                        loadDefault={false}
                                        returnOriginal={true}
                                        disabled={true}
                                        filtraFilial={true}
                                    />
                                </Col>
                                { campoPrioridade && campoPrioridade.value === '5' &&
                                    <Col md="6" xs="12">
                                        <SelectCentroCusto 
                                            label="Centro de Custo de Reposição"
                                            campoCentroCusto={campoCentroCustoReposicao}
                                            changeCentroCusto={handleCampoCentroCustoReposicao}
                                            empresaLogada={empresaFilial}
                                            queryCentroCusto={queryCentroCustoReposicao}
                                            loadDefault={false}
                                            returnOriginal={true}
                                            filtraFilial={true}
                                        />
                                    </Col>
                                }
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Endereço de Entrega"
                                        placeholder="Endereço de Entrega"
                                        tipo="text"
                                        value={campoEnderecoEntrega}
                                        onChange={(e) => setCampoEnderecoEntrega(e.target.value)}
                                        />
                                </Col>
                            </Row>
                            <HRDivider/>
                            <Row>
                                <Col md="10" xs="12">
                                    <h5>Dados Opcionais: </h5>
                                </Col>
                            </Row>
                            <Row>
                                { !obrigatorioValor && 
                                    <>
                                        <Col md="3" xs="12">
                                            <InputGeral
                                                label="Valor Unitário"
                                                placeholder="Valor Unitário"
                                                tipo="monetario"
                                                value={campoValorUnitario}
                                                onChange={(e) => handleCampoValorUnitario(e)}
                                                decimal={4}
                                            />
                                        </Col>
                                        <Col md="4" xs="12">
                                            <InputGeral
                                                label="Valor Total Meta"
                                                placeholder="Valor Total Meta"
                                                tipo="monetario"
                                                value={campoValorTotal}
                                                disabled={true}
                                                onChange={(e) => setCampoValorTotal(e)}
                                            />
                                        </Col>
                                    </>
                                }
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Descrição Complementar do Produto"
                                        placeholder="Descrição Complementar do Produto"
                                        tipo="text"
                                        value={campoDescricaoComplementar}
                                        onChange={(e) => setCampoDescricaoComplementar(e.target.value)}
                                        />
                                </Col>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Observação Interna do Item"
                                        placeholder="Observação Interna do Item"
                                        tipo="textArea"
                                        value={campoObservacaoInterna}
                                        onChange={(e) => setCampoObservacaoInterna(e.target.value)}
                                    />
                                </Col>
                                <Col md="12" xs="12">
                                    <InputGeral
                                        label="Observação ao Fornecedor do Item"
                                        placeholder="Observação Fornecedor"
                                        tipo="textArea"
                                        value={campoObservacaoFornecedor}
                                        onChange={(e) => setCampoObservacaoFornecedor(e.target.value)}
                                    />
                                </Col>
                                <Col md="12" xs="12">
                                    <LabelInput>Anexo Item SC</LabelInput>
                                    <UploadFiles 
                                        onDropEvent={handleAddFiles}
                                        onDeleteEvent={handleDelFiles}
                                        value={campoAnexosItem}
                                    />
                                </Col>
                            </Row>

                            <Row className="d-flex align-content-end align-items-end justify-content-end">
                                <Col md="2" xs="12" >
                                    <Button variant="primary" className="w-100" onClick={handleSaveItem}>
                                        { campoItem && '✓ Salvar' || '✚ Adicionar' }
                                    </Button>
                                </Col>
                                <Col md="2" xs="12" >
                                    <Button variant="warning" className="w-100" onClick={handleCancelItem}>
                                        ✗ Cancelar
                                    </Button>                    
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            )}
            { dataItensSolicitacao && dataItensSolicitacao.length > 0 &&
                <TrelloBoard 
                    columns={columnsItensSolicitacao} 
                    data={dataItensSolicitacao.filter((item) => item.deletado === false)} 
                    titleLista="Item: "
                    columnsAditional={columnsAditional}
                    buttons= { disabledForm ? [] : 
                            [   {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", style: "outline-info"},
                                {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger" }
                            ]
                    }
                    tamanhoCard="65lvh"
                />
            }
            { dataItensSolicitacao && dataItensSolicitacao.length > 0 && !propIdSolicitacaoCompras &&
                <SubmitForm 
                    onSave={ disabledForm ? null : handleSalvar}
                    onCancel={ disabledForm ? null : 'handleVoltar'}
                    onVoltar={ disabledForm ? 'handleVoltar' : null}
                />
            }
        </>
    );
}

export default FichaSolicitacaoCompra;